export default __webpack_public_path__ + "static/media/icon-interdit.d7dba0fa.svg";